export default __webpack_public_path__ + "bddc181a9f0b8bd018335f60ee462d47.svg";